import SEOHead from "@/components/SEOHead";
import { COMPANY } from "@/data/content";

export default function DatenschutzPage() {
  return (
    <>
      <SEOHead
        title={`Datenschutzerklärung – ${COMPANY.name}`}
        description={`Datenschutzerklärung der ${COMPANY.legalName} gemäß DSGVO und BDSG.`}
      />
      <section className="pt-32 pb-24 bg-white">
        <div className="max-w-[900px] mx-auto px-6 md:px-12" data-testid="datenschutz-page">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#2873B8] mb-3">Rechtliches</p>
          <h1 className="text-4xl md:text-5xl font-bold text-[#0C2749]" style={{ fontFamily: "Outfit" }}>
            Datenschutzerklärung
          </h1>
          <p className="text-sm text-slate-500 mt-3">
            Stand: {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}
          </p>

          <div className="mt-10 space-y-10 text-[#0C2749]">

            <Block title="1. Verantwortlicher im Sinne der DSGVO">
              <p>{COMPANY.legalName}</p>
              <p>{COMPANY.street}, {COMPANY.postal} {COMPANY.city}</p>
              <p>Deutschland</p>
              <p>Telefon: {COMPANY.phone}</p>
              <p>E-Mail: {COMPANY.email}</p>
            </Block>

            <Block title="2. Allgemeines zur Datenverarbeitung">
              <P>
                Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur Bereitstellung
                einer funktionsfähigen Website sowie unserer Inhalte und Leistungen erforderlich ist. Die Verarbeitung
                erfolgt regelmäßig nur nach Einwilligung des Nutzers oder wenn die Verarbeitung durch gesetzliche
                Vorschriften gestattet ist.
              </P>
              <P>
                Soweit für Verarbeitungsvorgänge personenbezogener Daten eine Einwilligung der betroffenen Person eingeholt wird,
                dient Art. 6 Abs. 1 lit. a DSGVO als Rechtsgrundlage. Bei Verarbeitungen zur Erfüllung eines Vertrags Art. 6 Abs. 1 lit. b DSGVO,
                bei rechtlichen Verpflichtungen Art. 6 Abs. 1 lit. c DSGVO und bei berechtigten Interessen Art. 6 Abs. 1 lit. f DSGVO.
              </P>
            </Block>

            <Block title="3. Bereitstellung der Website und Server-Log-Dateien">
              <P>
                Bei jedem Aufruf unserer Website erfasst unser System automatisiert Daten und Informationen des Computersystems
                des aufrufenden Rechners. Folgende Daten werden hierbei erhoben: Browsertyp und -version, verwendetes Betriebssystem,
                Referrer-URL, Hostname des zugreifenden Rechners, Uhrzeit der Serveranfrage, IP-Adresse.
              </P>
              <P>
                Die Daten werden in den Logfiles unseres Systems gespeichert. Eine Speicherung dieser Daten zusammen mit anderen
                personenbezogenen Daten des Nutzers findet nicht statt. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse
                an einer stabilen, sicheren Bereitstellung der Website). Die Daten werden gelöscht, sobald sie für die Zweckerreichung
                nicht mehr erforderlich sind, spätestens nach 30 Tagen.
              </P>
            </Block>

            <Block title="4. Kontaktformular und KI-Preisrechner">
              <P>
                Auf unserer Website befinden sich ein Kontaktformular sowie ein KI-Preisrechner, mit denen Sie auf elektronischem
                Wege Kontakt aufnehmen können. Wenn Sie diese Möglichkeit wahrnehmen, werden die in der Eingabemaske eingegebenen
                Daten (insbesondere Name, E-Mail-Adresse, Telefonnummer, Projektdaten) an uns übermittelt und gespeichert.
              </P>
              <P>
                Die Verarbeitung erfolgt zur Bearbeitung Ihrer Anfrage gemäß Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen)
                bzw. Art. 6 Abs. 1 lit. a DSGVO (Einwilligung über die Checkbox „Datenschutz akzeptieren"). Die Daten werden gelöscht,
                sobald sie für die Zweckerreichung nicht mehr erforderlich sind. Bei gesetzlichen Aufbewahrungspflichten (z. B. HGB, AO)
                erfolgt die Löschung nach Ablauf der Fristen.
              </P>
            </Block>

            <Block title="5. KI-gestützte Preisanalyse (Drittanbieter)">
              <P>
                Für die intelligente Empfehlung im Preisrechner setzen wir KI-Modelle ein (Claude Sonnet von Anthropic, ggf.
                OpenAI GPT). Hierbei werden ausschließlich die von Ihnen im Rechner ausgewählten Projektparameter (Quadratmeter,
                Gebäudetyp, Bauart, Standort, Qualität, Zusatzleistungen) an den Anbieter übermittelt. Personenbezogene Daten
                (Name, E-Mail, Telefon) werden nicht an den KI-Anbieter weitergeleitet.
              </P>
              <P>
                Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer qualifizierten Kostenindikation für den Nutzer).
              </P>
            </Block>

            <Block title="6. E-Mail-Versand über Resend">
              <P>
                Zur Zustellung von Anfrage-Benachrichtigungen nutzen wir den Dienst Resend (Resend Inc.). Dabei werden Ihre
                übermittelten Formulardaten an die E-Mail-Infrastruktur von Resend übergeben. Mit dem Anbieter besteht ein
                Auftragsverarbeitungsvertrag nach Art. 28 DSGVO.
              </P>
            </Block>

            <Block title="7. Cookies">
              <P>
                Diese Website verwendet ausschließlich technisch notwendige Cookies, die zum Betrieb der Seite und für die
                Anmeldung im internen Verwaltungsbereich erforderlich sind (z. B. Session-Cookies für JWT-Authentifizierung).
                Tracking- oder Marketing-Cookies werden nicht ohne Ihre ausdrückliche Einwilligung gesetzt.
              </P>
            </Block>

            <Block title="8. Hosting">
              <P>
                Die Website wird auf abgesicherten Servern innerhalb der Europäischen Union gehostet. Die Daten­übertragung
                erfolgt verschlüsselt über TLS (HTTPS).
              </P>
            </Block>

            <Block title="9. Google Maps">
              <P>
                Auf unserer Kontaktseite binden wir Karten von Google Maps (Google Ireland Limited) ein. Bei Aufruf der
                Kontaktseite werden Informationen über Ihre Nutzung an Google übertragen und ggf. in den USA gespeichert.
                Weitere Informationen entnehmen Sie der Datenschutzerklärung von Google:{" "}
                <a
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#2873B8] hover:underline"
                >
                  policies.google.com/privacy
                </a>.
              </P>
            </Block>

            <Block title="10. WhatsApp / Click-to-Call">
              <P>
                Auf unserer Website finden Sie Schaltflächen für WhatsApp und Click-to-Call. Wenn Sie auf eine dieser Schaltflächen
                klicken, werden Sie zu der jeweiligen App (WhatsApp Inc.) bzw. zur Telefon-Wähl-App Ihres Endgeräts weitergeleitet.
                Erst durch das aktive Anklicken werden Daten an WhatsApp übermittelt. Wir haben keinen Einfluss auf die Datenverarbeitung
                bei WhatsApp.
              </P>
            </Block>

            <Block title="11. Rechte der betroffenen Person">
              <P>
                Werden personenbezogene Daten von Ihnen verarbeitet, haben Sie folgende Rechte gegenüber dem Verantwortlichen:
              </P>
              <ul className="list-disc pl-6 space-y-1 text-[15px] text-slate-700">
                <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
                <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
                <li>Recht auf Löschung (Art. 17 DSGVO)</li>
                <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
                <li>Recht auf Widerspruch (Art. 21 DSGVO)</li>
                <li>Recht auf Widerruf einer erteilten Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
                <li>Recht auf Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)</li>
              </ul>
              <P>
                Zur Geltendmachung Ihrer Rechte genügt eine formlose Mitteilung an {COMPANY.email}.
              </P>
            </Block>

            <Block title="12. Zuständige Aufsichtsbehörde">
              <P>
                Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen<br />
                Kavalleriestraße 2–4, 40213 Düsseldorf<br />
                Telefon: 0211 38424-0 · E-Mail: poststelle@ldi.nrw.de
              </P>
            </Block>

            <Block title="13. Aktualität und Änderung dieser Datenschutzerklärung">
              <P>
                Diese Datenschutzerklärung ist aktuell gültig. Durch die Weiterentwicklung unserer Website oder geänderte
                gesetzliche Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern. Die jeweils aktuelle
                Fassung finden Sie unter{" "}
                <a href={`https://${COMPANY.website}/datenschutz`} className="text-[#2873B8] hover:underline">
                  {COMPANY.website}/datenschutz
                </a>.
              </P>
            </Block>

          </div>
        </div>
      </section>
    </>
  );
}

function Block({ title, children }) {
  return (
    <div>
      <h2 className="text-lg md:text-xl font-semibold mb-3" style={{ fontFamily: "Outfit" }}>
        {title}
      </h2>
      <div className="space-y-3">{children}</div>
    </div>
  );
}

function P({ children }) {
  return <p className="text-[15px] leading-relaxed text-slate-700">{children}</p>;
}
